import React from "react";
import { getTime } from "../utils/getTime";
/**
 * その作品が公開期間中であるかどうか。
 */

export const initialPublishedState = {
  soon: true,
  late: false,
  init: true
};

export const PublishedContext = React.createContext<
  [PublishedState, (state: PublishedState) => void]
>([initialPublishedState, () => {}]);

// 初期値としてContextに代入する実体。stateとそのセッターを与える。
export const usePublishedContext = (): [PublishedState, any] => {
  const [publishedState, setPublishedStateFunc] = React.useState(
    initialPublishedState
  );
  return [publishedState, setPublishedStateFunc];
};

export const procPublishedState = async (
  publishFrom: number,
  publishTo: number
): Promise<PublishedState> => {
  const serverTime = await getTime();
  return {
    soon: publishFrom > serverTime,
    late: publishTo < serverTime,
    init: false
  };
};
